import React, { useState } from 'react';
import { Marker, Popup } from 'react-map-gl';
import TreeMarker from './TreeMarker';

const TreeMarkers = (props) => {
  //const [showPopup, setShowPopup] = useState(null);
  const { trees, selectedTree, onClickTree } = props;
  return (
    <React.Fragment>
      {Object.keys(trees).map(treeKey => {
        const { lat, lon, plaque, side, number } = trees[treeKey];
        if (selectedTree !== null && selectedTree !== treeKey) return null;
        const isSelected = selectedTree !== null && selectedTree === treeKey;
        return (
          <React.Fragment key={treeKey}>
            {selectedTree === null || isSelected ? (
              <Marker latitude={lat} longitude={lon} offsetLeft={-20} offsetTop={-20}>
                <TreeMarker
                  onClick={e => onClickTree(treeKey)}
                  // onMouseOver={e => setShowPopup(treeKey)}
                  // onMouseOut={e => setShowPopup(null)}
                  selectedTree={selectedTree}
                  isSelected={isSelected}
                />
              </Marker>
            ) : null}
            {/* {showPopup === treeKey ? (
              <Popup latitude={lat} longitude={lon} closeButton={false} anchor="bottom">
                <div style={{ fontSize: '0.75rem' }}>
                  <strong>{`${side} ${number}`}</strong> - {plaque}
                </div>
              </Popup>
            ) : null} */}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default TreeMarkers;
